// extracted by mini-css-extract-plugin
export default {"item":"order-card-ingridient_item__fuhd0","icon":"order-card-ingridient_icon__Y0Nml","name":"order-card-ingridient_name__HJGyf","price":"order-card-ingridient_price__x6MWP"};